import { debounce } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';

export const useDebouncedState = <T>(initialValue: T, delay: number = 500) => {
  const [state, setState] = useState(initialValue);
  const [debouncedState, setDebouncedState] = useState(initialValue);

  const debouncedUpdate = useCallback(
    debounce((value: T) => {
      setDebouncedState(() => value);
    }, delay),
    [],
  );

  const onChange = (value: T) => {
    setState(value);
    debouncedUpdate(value);
  };

  useEffect(() => {
    return () => {
      debouncedUpdate.cancel();
    };
  }, [debouncedUpdate]);

  return {
    state,
    debouncedState,
    onChange,
  };
};
